import React, { useCallback, useEffect, useRef, useState } from "react";
import { heading1 } from "../../utils/helperData";
import { HiDotsVertical } from "react-icons/hi";
import { IoIosSearch } from "react-icons/io";
import { CgAddR } from "react-icons/cg";
import Pagination from "../../customComponent/Pagination";
import { useNavigate } from "react-router";
import { IoMdArrowDropup, IoMdArrowDropdown } from "react-icons/io";
import {
  ADD_PROJECT,
  EDIT_MANAGE_PROJECT_DETAILS,
  VIEW_MANAGE_PROJECT_DETAILS,
} from "../../utils/RouteConstant";
import { Box, Menu, MenuItem, Modal } from "@mui/material";
import Danger from "../../../asesst/Danger.svg";
import Eye from "../../../asesst/Eye.svg";
import Vector from "../../../asesst/Vector.svg";
import Trash from "../../../asesst/Trash.svg";
import { RxCrossCircled } from "react-icons/rx";
import { IoCheckmarkDone, IoCopyOutline } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  copyProject,
  deleteProject,
  fetchProjectList,
  mergeProject,
  projectMarkasComplete,
} from "../../../redux/action/ProjectManagement/ProjectManagentAction";

const ManageProject = () => {
  const [modalState, setModalState] = useState({
    isOpen: false,
    type: "",
    projectId: null,
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const rowsPerPageOptions = [10, 20, 50, 100, "All"];
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const [mergeModalOpen, setMergeModalOpen] = useState(false);
  const [mergeForm, setMergeForm] = useState({
    sourceProjectId: "",
    targetProjectId: "",
  });
  const { projectData, totalCount } = useSelector((state) => state.project);
  const [sortConfig, setSortConfig] = useState({
    field: "updatedAt",
    order: "DESC",
  });

  const debounceTimerRef = useRef(null);
  const fetchProjects = useCallback(
    (term = "") => {
      setCurrentPage(1);
      dispatch(
        fetchProjectList(
          1,
          term,
          rowsPerPage,
          sortConfig.field,
          sortConfig.order,
          // sortConfig.field === "updatedAt" ? null : sortConfig.field,
          // sortConfig.order === "DESC" ? null : sortConfig.order
        ),
      );
    },
    [dispatch, sortConfig.field, sortConfig.order, rowsPerPage],
  );
  const debouncedHandleSearch = useCallback(
    (searchValue) => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
      debounceTimerRef.current = setTimeout(() => {
        fetchProjects(searchValue);
      }, 500);
    },
    [fetchProjects],
  );

  useEffect(() => {
    dispatch(
      fetchProjectList(
        currentPage,
        searchTerm,
        rowsPerPage,
        sortConfig.field,
        sortConfig.order,
        // sortConfig.field === "updatedAt" ? null : sortConfig.field,
        // sortConfig.order === "DESC" ? null : sortConfig.order
      ),
    );
  }, [
    dispatch,
    currentPage,
    searchTerm,
    sortConfig.field,
    sortConfig.order,
    rowsPerPage,
  ]);

  // const totalPages = Math.ceil(totalCount / itemsPerPage);

  const totalPages =
    rowsPerPage === "All" ? 1 : Math.ceil(totalCount / rowsPerPage);

  const handleRowsPerPageChange = (event) => {
    const value = event.target.value;
    if (value === "All") {
      setRowsPerPage(totalCount);
      setCurrentPage(1);
    } else {
      setRowsPerPage(Number(value));
      setCurrentPage(1);
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
      debounceTimerRef.current = null;
    }

    if (value.length >= 3) {
      debouncedHandleSearch(value);
    } else if (value.length === 0) {
      fetchProjects("");
    }
  };

  useEffect(() => {
    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, []);
  const handleAddInspector = () => {
    navigate(ADD_PROJECT);
  };

  const handleOpenUserMenu = (event, projectId) => {
    setAnchorElUser(event.currentTarget);
    setSelectedProjectId(projectId);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
    setSelectedProjectId(null);
  };

  const openModal = (type) => {
    setModalState({ isOpen: true, type, projectId: selectedProjectId });
    handleCloseUserMenu();
  };

  const closeModal = () => {
    setModalState({ isOpen: false, type: "", projectId: null });
  };

  const openMergeModal = () => {
    const preselectedProjectId = selectedProjectId || "";
    setMergeForm({
      sourceProjectId: preselectedProjectId,
      targetProjectId: "",
    });
    setMergeModalOpen(true);
    handleCloseUserMenu();
  };

  const closeMergeModal = () => {
    setMergeModalOpen(false);
    setMergeForm({ sourceProjectId: "", targetProjectId: "" });
  };

  const handleViewProjectDetails = (projectId) => {
    console.log("Navigating to details for inspector:", projectId);
    navigate(`${VIEW_MANAGE_PROJECT_DETAILS}/${projectId}`);
    handleCloseUserMenu();
  };

  const handleEditProjectDetails = (projectId) => {
    console.log("Navigating to details for inspector:", projectId);
    navigate(`${EDIT_MANAGE_PROJECT_DETAILS}/${projectId}`);
    handleCloseUserMenu();
  };

  const handleDeleteProject = () => {
    if (modalState.projectId) {
      dispatch(deleteProject(modalState.projectId)).then(() => {
        dispatch(fetchProjectList(currentPage, searchTerm, rowsPerPage));
        closeModal();
      });
    }
  };

  const handleMarkAsComplete = () => {
    if (modalState.projectId) {
      dispatch(projectMarkasComplete(modalState.projectId)).then(() => {
        dispatch(fetchProjectList(currentPage, searchTerm, rowsPerPage));
        closeModal();
      });
    }
  };

  const handleCopyProject = async () => {
    if (!modalState.projectId) return;
    try {
      const response = await dispatch(copyProject(modalState.projectId));
      toast.success(response?.message || "Project copied successfully");
      dispatch(fetchProjectList(currentPage, searchTerm, rowsPerPage));
      closeModal();
    } catch (err) {
      const errorMessage =
        err?.response?.data?.message ||
        err?.message ||
        "Failed to copy project";
      toast.error(errorMessage);
    }
  };

  const handleMergeProject = async () => {
    if (!mergeForm.sourceProjectId || !mergeForm.targetProjectId) {
      toast.error("Please select source and destination project");
      return;
    }
    if (mergeForm.sourceProjectId === mergeForm.targetProjectId) {
      toast.error("Source and destination project cannot be the same");
      return;
    }

    try {
      const response = await dispatch(
        mergeProject(mergeForm.sourceProjectId, mergeForm.targetProjectId),
      );
      toast.success(response?.message || "Project merged successfully");
      dispatch(fetchProjectList(currentPage, searchTerm, rowsPerPage));
      closeMergeModal();
    } catch (err) {
      const errorMessage =
        err?.response?.data?.message ||
        err?.message ||
        "Failed to merge project";
      toast.error(errorMessage);
    }
  };

  const getModalContent = () => {
    if (modalState.type === "delete") {
      return {
        title: "Delete Project",
        message: "Are you sure you want to permanently delete this project?",
        confirmText: "Yes",
        onConfirm: handleDeleteProject,
      };
    } else if (modalState.type === "copy") {
      return {
        title: "Copy Project",
        message: "Are you sure you want to copy this project?",
        confirmText: "Yes",
        onConfirm: handleCopyProject,
      };
    } else if (modalState.type === "complete") {
      return {
        title: "Mark as Complete",
        message: "Are you sure you want to mark this project completed?",
        confirmText: "Yes",
        onConfirm: handleMarkAsComplete,
      };
    }
    return {};
  };

  const modalContent = getModalContent();

  const truncateString = (str) => {
    if (str?.length > 20) {
      return str.slice(0, 20) + "...";
    }
    return str;
  };

  const selectedProject = projectData?.data?.data.find(
    (project) => project._id === selectedProjectId,
  );

  const handleSort = (field) => {
    setSortConfig((prevSort) => ({
      field,
      order:
        prevSort.field === field && prevSort.order === "ASC" ? "DESC" : "ASC",
    }));
  };

  const SortIcon = ({ column }) => {
    if (sortConfig.field !== column) {
      return (
        <div className="inline-flex flex-col ml-1">
          <IoMdArrowDropup className="text-gray-300" />
          <IoMdArrowDropdown className="text-gray-300 -mt-2" />
        </div>
      );
    }
    return sortConfig.order === "ASC" ? (
      <IoMdArrowDropup className="inline ml-1 text-blue-600" />
    ) : (
      <IoMdArrowDropdown className="inline ml-1 text-blue-600" />
    );
  };

  const getBackendFieldName = (columnName) => {
    const fieldMap = {
      ID: "project_id",
      "Project Name": "project_name",
      "Last Modified": "updatedAt",
    };
    return fieldMap[columnName] || columnName.toLowerCase();
  };

  const renderHeader = () => (
    <thead className="bg-[#F1F4F9]">
      <tr>
        {heading1.map((head) => (
          <th
            key={head.name}
            scope="col"
            className={`px-6 py-3 text-left text-base font-medium text-[#202224] uppercase tracking-wider ${
              ["ID", "Project Name", "Last Modified"].includes(head.name)
                ? "cursor-pointer hover:bg-gray-100"
                : ""
            }`}
            onClick={() => {
              if (["ID", "Project Name", "Last Modified"].includes(head.name)) {
                handleSort(getBackendFieldName(head.name));
              }
            }}
          >
            <div className="flex items-center">
              {head.name}
              {["ID", "Project Name", "Last Modified"].includes(head.name) && (
                <SortIcon column={getBackendFieldName(head.name)} />
              )}
            </div>
          </th>
        ))}
      </tr>
    </thead>
  );

  return (
    <div>
      <h1 className="text-3xl sm:text-3xl text-[#202224] font-bold mb-6">
        Project Management
      </h1>
      <div className="flex flex-col sm:flex-row justify-between items-center mb-6 space-y-4 sm:space-y-0 sm:space-x-4">
        <div className="relative w-full sm:w-64 flex-grow sm:flex-grow-0">
          <input
            type="text"
            placeholder="Search"
            value={searchTerm}
            onChange={handleSearch}
            className="w-full lg:w-[400px] pl-10 pr-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
          <IoIosSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
        </div>
        <button
          onClick={handleAddInspector}
          className="w-full sm:w-auto bg-[#1C3664] text-white px-4 py-2 rounded-lg flex items-center justify-center hover:bg-blue-900 transition-colors"
        >
          <CgAddR className="mr-2" />
          Add New Project
        </button>
      </div>
      <div className="bg-white rounded-2xl shadow-sm p-4 sm:p-6">
        <div className="flex flex-col sm:flex-row justify-between items-center mb-6 space-y-4 sm:space-y-0 sm:space-x-4">
          <div className="relative w-full sm:w-64 flex-grow sm:flex-grow-0">
            <span className="font-semibbold text-2xl">Project Details</span>
          </div>
        </div>
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            {renderHeader()}
            <tbody className="bg-white divide-y divide-gray-200">
              {/* {projectData?.data?.data?.map((project, index) => ( */}
              {projectData?.data?.data?.length > 0 ? (
                <>
                  {projectData?.data?.data?.map((project, index) => (
                    <tr key={project._id}>
                      <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-500">
                        {(currentPage - 1) * rowsPerPage + index + 1}
                      </td>
                      <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-500">
                        {project?.project_id}
                      </td>
                      <td className="px-6 py-3 whitespace-nowrap text-sm  text-gray-500">
                        {project?.project_name}
                      </td>
                      <td className="px-6 py-3 whitespace-nowrap cursor-pointer text-sm text-gray-500">
                        <span
                          title={
                            project?.inspectors_info
                              .map((inspector) => inspector.inspector_assigned)
                              .join(", ") || "-"
                          }
                        >
                          {truncateString(
                            project?.inspectors_info
                              .map((inspector) => inspector.inspector_assigned)
                              .join(", ") || "-",
                          )}
                        </span>
                      </td>
                      <td className="px-6 py-3 whitespace-nowrap">
                        <span
                          style={{
                            width: "100px",
                            textAlign: "center",
                            justifyContent: "center",
                          }}
                          className={`px-4 py-1 inline-flex text-xs leading-5 font-base rounded-full ${
                            project.status === "Assigned"
                              ? "bg-[#467FE4] text-[#FFFFFF]"
                              : project.status === "Completed"
                                ? "bg-[#0AA43D] text-[#FFFFFF]"
                                : project?.status === "Draft"
                                  ? "bg-yellow-400 text-[#FFFFFF]"
                                  : "bg-[#FB8787] text-[#FFFFFF]"
                          }`}
                        >
                          {project?.status}
                        </span>
                      </td>
                      <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-500">
                        {/* {project?.last_modified} */}
                        {project?.last_modified
                          ? (() => {
                              const parts = project?.last_modified.split("-");
                              const formattedDate = new Date(
                                `${parts[0]}/${parts[1]}/${parts[2]}`,
                              );
                              return formattedDate.toLocaleDateString("en-US", {
                                month: "2-digit",
                                day: "2-digit",
                                year: "numeric",
                              });
                            })()
                          : "-"}
                      </td>
                      <td className="px-6 py-3 whitespace-nowrap text-sm font-medium">
                        <button
                          onClick={(event) =>
                            handleOpenUserMenu(event, project._id)
                          }
                          className="text-gray-400 hover:text-gray-500"
                        >
                          <HiDotsVertical />
                        </button>
                      </td>
                    </tr>
                  ))}
                </>
              ) : (
                <tr>
                  <td colSpan="8" className="px-6 py-4 text-center">
                    <div className="flex flex-col items-center justify-center">
                      <img
                        src="https://img.freepik.com/premium-vector/no-data-concept-illustration_86047-488.jpg?semt=ais_hybrid"
                        alt="No Data"
                        className="mb-4 w-[200px] h-[200px]"
                      />
                      <p className="text-lg text-gray-500">
                        No Inspector created.
                      </p>
                      <p className="text-sm text-gray-400">
                        Please check back later or created new inspector.
                      </p>
                    </div>
                  </td>
                </tr>
              )}
              <Menu
                id="menu-appbar"
                sx={{ mt: "22px" }}
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                <div className="flex flex-col space-y-[-2px]">
                  <MenuItem>
                    <span
                      className="text-[#1C3664] text-base font-poppins flex items-center"
                      onClick={() =>
                        handleViewProjectDetails(selectedProjectId)
                      }
                    >
                      <img src={Eye} alt="view details" className="mr-2" />
                      View Details
                    </span>
                  </MenuItem>
                  <MenuItem>
                    <span
                      className="text-[#1C3664] text-base font-poppins flex items-center"
                      onClick={() =>
                        handleEditProjectDetails(selectedProjectId)
                      }
                    >
                      <img src={Vector} alt="edit details" className="mr-2" />
                      Edit Details
                    </span>
                  </MenuItem>
                  {selectedProject?.status !== "Completed" ? (
                    <MenuItem>
                      <span
                        onClick={() => openModal("complete")}
                        className="text-[#1C3664] text-base font-poppins flex items-center"
                      >
                        <IoCheckmarkDone className="mr-2" />
                        Mark as Completed
                      </span>
                    </MenuItem>
                  ) : (
                    <MenuItem>
                      <span
                        onClick={() => openModal("complete")}
                        className="text-[#1C3664] text-base font-poppins flex items-center"
                      >
                        <IoCheckmarkDone className="mr-2" />
                        Mark as Ongoing
                      </span>
                    </MenuItem>
                  )}
                  {/* <MenuItem>
                    <span className="text-[#1C3664] text-base font-poppins flex items-center">
                      <IoCopyOutline className="mr-2" />
                      Copy Project
                    </span>
                  </MenuItem>  */}
                  <MenuItem>
                    <span
                      onClick={() => openModal("delete")}
                      className="text-[#FF5C5C] text-base font-poppins flex items-center"
                    >
                      <img src={Trash} alt="delete" className="mr-2" />
                      Delete
                    </span>
                  </MenuItem>
                  <MenuItem>
                    <span
                      onClick={() => openModal("copy")}
                      className="text-[#1C3664] text-base font-poppins flex items-center"
                    >
                      <IoCopyOutline className="mr-2" />
                      Copy Project
                    </span>
                  </MenuItem>
                  <MenuItem>
                    <span
                      onClick={openMergeModal}
                      className="text-[#1C3664] text-base font-poppins flex items-center"
                    >
                      <IoCheckmarkDone className="mr-2" />
                      Merge Project
                    </span>
                  </MenuItem>
                </div>
              </Menu>
            </tbody>
          </table>

          <Modal
            open={modalState.isOpen}
            className="justiify-center items-center flex"
          >
            <Box className="bg-white text-center p-4 rounded-2xl shadow-md max-w-lg mx-auto">
              <RxCrossCircled
                onClick={closeModal}
                className="float-end top-2 h-6 w-6 cursor-pointer"
              />
              <div className="text-center inline-flex mt-8">
                <div className=" flex items-center justify-center">
                  <img src={Danger} alt="Success" className="w-full h-full " />
                </div>
              </div>
              <div className="text-center">
                <h2 className="text-3xl text-[#0B0B0B] mt-2 font-semibold">
                  {modalContent.title}
                </h2>
                <p className="font-normal text-lg mt-2 text-[#6D6D6D]">
                  {modalContent.message}
                </p>
              </div>
              <div className="flex justify-center space-x-6 my-6">
                <button
                  onClick={modalContent.onConfirm}
                  className="bg-[#FFFFFF] border w-[70px] px-4 py-2 rounded-lg"
                >
                  {modalContent.confirmText}
                </button>
                <button
                  onClick={closeModal}
                  className="bg-[#1C3664] border w-[70px] text-white px-4 py-2 rounded-lg"
                >
                  No
                </button>
              </div>
            </Box>
          </Modal>

          <Modal
            open={mergeModalOpen}
            className="justiify-center items-center flex"
          >
            <Box className="bg-white p-6 rounded-2xl shadow-md w-[95%] max-w-lg mx-auto">
              <RxCrossCircled
                onClick={closeMergeModal}
                className="float-end top-2 h-6 w-6 cursor-pointer"
              />
              <div className="text-center mt-4">
                <h2 className="text-3xl text-[#0B0B0B] font-semibold">
                  Merge Project
                </h2>
                <p className="font-normal text-base mt-2 text-[#6D6D6D]">
                  Select source and destination project
                </p>
              </div>

              <div className="mt-6 space-y-4">
                <div>
                  <label
                    htmlFor="source-project"
                    className="block text-sm font-medium text-[#202224] mb-2"
                  >
                    Source Project
                  </label>
                  <select
                    id="source-project"
                    value={mergeForm.sourceProjectId}
                    onChange={(e) =>
                      setMergeForm((prev) => ({
                        ...prev,
                        sourceProjectId: e.target.value,
                      }))
                    }
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none"
                  >
                    <option value="">Select source project</option>
                    {projectData?.data?.data?.map((project) => (
                      <option key={project._id} value={project._id}>
                        {project?.project_name || project?.project_id}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label
                    htmlFor="destination-project"
                    className="block text-sm font-medium text-[#202224] mb-2"
                  >
                    Destination Project
                  </label>
                  <select
                    id="destination-project"
                    value={mergeForm.targetProjectId}
                    onChange={(e) =>
                      setMergeForm((prev) => ({
                        ...prev,
                        targetProjectId: e.target.value,
                      }))
                    }
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none"
                  >
                    <option value="">Select destination project</option>
                    {projectData?.data?.data?.map((project) => (
                      <option key={project._id} value={project._id}>
                        {project?.project_name || project?.project_id}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="flex justify-center space-x-6 mt-8">
                <button
                  onClick={closeMergeModal}
                  className="bg-[#FFFFFF] border px-6 py-2 rounded-lg"
                >
                  Cancel
                </button>
                <button
                  onClick={handleMergeProject}
                  className="bg-[#1C3664] border text-white px-6 py-2 rounded-lg"
                >
                  Merge
                </button>
              </div>
            </Box>
          </Modal>
        </div>
      </div>
      <div className="flex items-center justify-end mb-4 space-x-3">
        <div className="flex items-center mt-6 ">
          <label htmlFor="rows-per-page" className="mr-2">
            Rows per page:
          </label>
          <select
            id="rows-per-page"
            value={rowsPerPage}
            onChange={handleRowsPerPageChange}
            className="border border-solid border-2 h-[34px] rounded p-1 text-gray-500"
          >
            {rowsPerPageOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>

        {totalPages > 1 && rowsPerPage !== "All" && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
          />
        )}
      </div>
      {/* {totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
        />
      )} */}
    </div>
  );
};
export default ManageProject;
